module.exports = __webpack_public_path__ + "static/media/new-logo.85b644fd.png";